// import { ipcRenderer } from 'electron'
import isElectron from 'is-electron'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import ReactTooltip from 'react-tooltip'
import classnames from 'classnames'
import compareVersions from 'compare-versions'

import Button from './UI/Button'
import Toggle from './UI/Toggle'
import NumberInput from './UI/NumberInput'
import FloatNumberInput from "./UI/FloatNumberInput";

import malletStationLogo from '../svg/malletStation-logo.svg';
import tooltips from '../constants/tooltips.json'

// import { asyncLocalStorage } from '../utilities/'
import { isLinux } from '../utilities/'

import {
  toggleUISync,
  toggleTooltips,
  toggleAutohideZoneSlider,
  openPreferences,
  fetchFirmware,
  resetDevice,
  downloadUserPresets,
  toggleShowLearnModeTour,
} from "../actions";

class Preferences extends Component {
  componentDidMount() {
    /*
    if(isElectron()) {
      const menu = remote.Menu.getApplicationMenu()
      // set menu item
      asyncLocalStorage.getItem('malletstation_editorPreferences').then(preferences => {
        menu.getMenuItemById('show_tooltips').checked = JSON.parse(preferences).showTooltips
      })
      // ipc events
      ipcRenderer.on('toggle-tooltips', (event, value) => this.props.onToggleTooltips(value))
      ipcRenderer.on('preset-export', () => this.props.onDownloadUserPresets())
      ipcRenderer.on('firmware-update', () => this.props.onFetchFirmware(this.props.availableFirmware.url))
    }
    */
  }

  componentWillUnmount() {
    /*
    if(isElectron()) {
      ipcRenderer.removeAllListeners('toggle-tooltips')
      ipcRenderer.removeAllListeners('preset-export')
      ipcRenderer.removeAllListeners('firmware-update')
    }
    */
  }

  handleCloseModal = () => {
    this.props.onClosePreferences()
  }

  afterOpenModal = () => {
    ReactTooltip.rebuild()
  }

  render() {
    const {
      preferencesOpen,
      statusMessage,
      deviceConnected,
      networkConnection,
      firmwareVersion,
      availableFirmware,
      updatingFirmware,
      bootloaderMode,
      editorVersion,
      availableEditor,
      legacyFirmwareVersion,
      uiSync,
      showTooltips,
      autohideSliders,
      showLearnModeTour,
      onFetchFirmware,
      onToggleUISync,
      onToggleTooltips,
      onToggleZoneSliders,
      onResetDevice,
      onDownloadUserPresets,
      onToggleShowLearnModeTour,
    } = this.props;

    let formattedMessage = statusMessage.replace(/\s+/g, '-')

    return (
      <div className="preferences-modal">
        <ReactModal
          isOpen={preferencesOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.handleCloseModal}
          shouldCloseOnOverlayClick={true}
          className="react-modal"
          overlayClassName="react-modal-overlay"
          contentLabel="Preferences"
        >
          <div
            className={classnames(
              "preferences-panel"
              // {'electron': isElectron()}
            )}
          >
            <div className="logo">
              <img
                className="malletStation-logo"
                src={malletStationLogo}
                draggable="false"
                alt="malletStation EM1"
              />
            </div>
            <div className="status-message">{statusMessage}</div>
            <div className="status-bar" data-status-message={formattedMessage}>
              <span className="progress-bar"></span>
            </div>
            <div
              className="device-versions"
              data-tip={tooltips["preferences-versions"]}
              data-multiline="true"
              data-place="top"
              data-tip-disable={!showTooltips}
            >
              <span className="label">Editor:</span>
              <span className="version">v.{editorVersion}</span>
              {availableEditor &&
                compareVersions(availableEditor.version, editorVersion) ===
                  1 && (
                  <span className="update-message editor-update">
                    v.{availableEditor.version} available
                  </span>
                )}
              <br />
              <span className="label">Firmware:</span>
              <span className="version">v.{firmwareVersion}</span>
              {availableFirmware &&
                compareVersions(availableFirmware.version, firmwareVersion) ===
                  1 &&
                deviceConnected && (
                  <span className="update-message firmware-update">
                    v.{availableFirmware.version} available
                  </span>
                )}
            </div>
            <div className="pref-section editor-prefs">
              <h3 className="pref-header">Editor</h3>
              <div className="label-button toggle-item">
                <label
                  className={classnames("label-ui-sync", {
                    disabled: !deviceConnected,
                  })}
                  data-tip={tooltips["preferences-ui-sync"]}
                  data-multiline="true"
                  data-place="bottom"
                  data-tip-disable={!showTooltips}
                >
                  UI Sync
                </label>
                <Toggle
                  checked={uiSync}
                  disabled={!deviceConnected ? true : false}
                  onChange={(event) => onToggleUISync(event.target.checked)}
                />
              </div>
              <div className="label-button toggle-item">
                <label
                  data-tip={tooltips["preferences-tooltips"]}
                  data-multiline="true"
                  data-place="bottom"
                  data-tip-disable={!showTooltips}
                >
                  Tooltips
                </label>
                <Toggle
                  checked={showTooltips}
                  onChange={(event) => {
                    /*
                  if(isElectron()) {
                      const menu = remote.Menu.getApplicationMenu()
                      // set menu item
                      asyncLocalStorage.getItem('malletstation_editorPreferences').then(preferences => {
                        menu.getMenuItemById('show_tooltips').checked = JSON.parse(preferences).showTooltips
                      })
                    }
                  */
                    onToggleTooltips(event.target.checked);
                  }}
                />
              </div>
              <div className="label-button toggle-item">
                <label
                  data-tip={tooltips["preferences-autohide-zone-handles"]}
                  data-multiline="true"
                  data-place="bottom"
                  data-tip-disable={!showTooltips}
                >
                  Autohide Slider Handles
                </label>
                <Toggle
                  checked={autohideSliders}
                  onChange={(event) =>
                    onToggleZoneSliders(event.target.checked)
                  }
                />
              </div>
              <div className="label-button toggle-item">
                <label
                  data-tip={tooltips["preferences-show-learn-mode-tour"]}
                  data-multiline="true"
                  data-place="bottom"
                  data-tip-disable={!showTooltips}
                >
                  Show Learn Mode Tour
                </label>
                <Toggle
                  checked={showLearnModeTour}
                  onChange={(event) =>
                    onToggleShowLearnModeTour(event.target.checked)
                  }
                />
              </div>
            </div>
            <div className="pref-section presets-prefs">
              <h3 className="pref-header">Presets</h3>
              <div className="label-button">
                Export User Presets
                <Button
                  name="Export"
                  data-tip={tooltips["preferences-export-user-presets"]}
                  data-multiline="true"
                  data-place="bottom"
                  data-tip-disable={!showTooltips}
                  onClick={onDownloadUserPresets}
                />
              </div>
            </div>
            <div className="pref-section device-prefs">
              <h3
                className={classnames("pref-header", {
                  disabled: !deviceConnected,
                })}
              >
                Device
              </h3>
              <div
                className={classnames("label-button", {
                  disabled: !deviceConnected,
                })}
              >
                Device Reset
                <Button
                  name="Reset"
                  data-tip={tooltips["preferences-device-reset"]}
                  data-multiline="true"
                  data-place="top"
                  data-type="error"
                  data-tip-disable={!showTooltips}
                  disabled={!deviceConnected ? true : ""}
                  onClick={onResetDevice}
                />
              </div>
              <div
                className={classnames("label-button", {
                  disabled:
                    (!deviceConnected && !bootloaderMode) ||
                    (isElectron() ? false : !networkConnection),
                })}
              >
                Update Firmware
                <Button
                  name="Update"
                  data-tip={tooltips["preferences-update-firmware"]}
                  data-multiline="true"
                  data-place="bottom"
                  data-tip-disable={!showTooltips}
                  disabled={
                    (!deviceConnected && !bootloaderMode) ||
                    (isElectron() ? false : !networkConnection) ||
                    updatingFirmware ||
                    isLinux()
                      ? "disabled"
                      : ""
                  }
                  onClick={() => {
                    if (
                      compareVersions(
                        legacyFirmwareVersion,
                        firmwareVersion
                      ) !== -1
                    ) {
                      // <= 1.0.4
                      if (
                        window.confirm(
                          "Upgrading to this firmware is permanent and cannot be undone. This firmware requires you to Bar Regulate your malletSTATION afterwards."
                        )
                      ) {
                        setTimeout(
                          () => onFetchFirmware(availableFirmware.url),
                          3000
                        );
                      } else {
                        console.warn(
                          "malletStation: you chose not to upgrade your malletSTATION"
                        );
                      }
                    } else {
                      // all other versions
                      setTimeout(
                        () => onFetchFirmware(availableFirmware.url),
                        0
                      );
                    }
                  }}
                />
              </div>
            </div>
            <div
              className="close"
              data-tip={tooltips["preferences-close"]}
              data-multiline="true"
              data-place="right"
              data-tip-disable={!showTooltips}
              onClick={this.handleCloseModal}
            >
              X
            </div>
          </div>
        </ReactModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    statusMessage: state.editor.statusMessage,
    networkConnection: state.editor.networkConnection,
    preferencesOpen: state.editor.preferencesOpen,
    editorVersion: state.editor.editorVersion,
    availableEditor: state.editor.availableEditor,
    uiSync: state.editorPreferences.uiSync,
    showTooltips: state.editorPreferences.showTooltips,
    autohideSliders: state.editorPreferences.autohideSliders,
    showLearnModeTour: state.editorPreferences.showLearnModeTour,
    deviceConnected: state.device.connected,
    firmwareVersion: state.device.firmwareVersion,
    updatingFirmware: state.device.updatingFirmware,
    availableFirmware: state.device.availableFirmware,
    bootloaderMode: state.device.bootloaderMode,
    legacyFirmwareVersion: state.device.legacyFirmwareVersion
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onClosePreferences: () => {
      dispatch(openPreferences(false));
    },
    onToggleUISync: (active) => {
      dispatch(toggleUISync(active));
    },
    onToggleTooltips: (active) => {
      dispatch(toggleTooltips(active));
    },
    onToggleZoneSliders: (active) => {
      dispatch(toggleAutohideZoneSlider(active));
    },
    onToggleShowLearnModeTour: (active) => {
      dispatch(toggleShowLearnModeTour(active));
    },
    onResetDevice: () => {
      dispatch(resetDevice());
    },
    onDownloadUserPresets: () => {
      dispatch(downloadUserPresets());
    },
    onFetchFirmware: (url) => {
      dispatch(fetchFirmware(url));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Preferences)
